export const REGISTER_GYM_SUCCESS = 'REGISTER_GYM_SUCCESS'
export const REGISTER_GYM_FAILURE = 'REGISTER_GYM_FAILURE'
export const REGISTER_COACH_SUCCESS = 'REGISTER_COACH_SUCCESS'
export const REGISTER_COACH_FAILURE = 'REGISTER_COACH_FAILURE'
